import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetUWMarginDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_UWMARGIN_DETAILS, token);
  return res;
};

export const GetRubDetail = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_UWMARGIN_DETAILS_BY_ID + id, token);
  return res;
};

export const AddUWMargin = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_UWMARGIN, payload, token);
  return res;
};

export const DeleteUWMargin = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_UWMARGIN + id, id, token);
  return res;
};

export const UpdateUWMargin = async (id, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_UWMARGIN + id, payload, token);
  return res;
};
